import * as yup from 'yup'

declare module 'yup' {
  interface MixedSchema {
    maxFileSize(maxSize: number, message?: string): MixedSchema
    minFileSize(minSize?: number, message?: string): MixedSchema
    fileType(allowedTypes: string[], message?: string): MixedSchema
    fileExtension(allowedExtensions: string[], message?: string): MixedSchema
  }
}

// @ts-ignore
yup.addMethod(yup.mixed, 'maxFileSize', function (maxSize, message) {
  return this.test(
    'fileSize',
    message || `File size must be less than ${maxSize / (1024 * 1024)}MB`,
    (value?: File) => !!value && value.size <= maxSize,
  )
})

// @ts-ignore
yup.addMethod(yup.mixed, 'minFileSize', function (minSize = 0, message) {
  return this.test(
    'fileSize',
    message || `File size must be less than ${minSize / (1024 * 1024)}MB`,
    (value?: File) => !!value && value.size > minSize,
  )
})

// @ts-ignore
yup.addMethod(yup.mixed, 'fileType', function (allowedTypes, message) {
  return this.test(
    'fileType',
    message || `File type must be one of ${allowedTypes.join(', ')}`,
    (value?: File) => !!value && allowedTypes.includes(value.type),
  )
})

// @ts-ignore
yup.addMethod(yup.mixed, 'fileExtension', function (allowedExtensions, message) {
  return this.test(
    'fileExtension',
    message || `File extension must be one of ${allowedExtensions.join(', ')}`,
    (value?: File) => {
      if (!value || !value.name) return false
      const fileName = value.name.toLowerCase()
      return allowedExtensions.some((ext: string) => fileName.endsWith(`.${ext.toLowerCase()}`))
    },
  )
})

export const validationSchema = yup
  .mixed<File>()
  .required('A file is required')
  .fileExtension(['md', 'txt', 'pdf'], 'File extension is not valid, it must be either .md, .txt or .pdf')
  .minFileSize(0, 'File is empty')
  .maxFileSize(10 * 1024 * 1024, 'File is too big, the limit is 10 megabytes')
